function dispatchableStringItemIs(
  foundHierachy,
  nextItem,
  requiredArray,
  dateHierarchy
) {
  // console.log(nextItem);
  // console.log(dateHierarchy);
  const rowsArray = requiredArray.map((rItem) => {
    return {
      columnName: rItem.columnName,
      rename: rItem.rename,
      uuid: rItem.uuid,
      _id: rItem._id,
      dataType: rItem.dataType,
      nanoId: rItem.nanoId,
      format: rItem.format,
      dateFormat: rItem.dateFormat,
    };
  });
  // console.log(rowsArray);

  const hierarchyUUIDs = foundHierachy.hierarchyArray.map((item) => item.uuid);
  const hierarchyItems = requiredArray
    .filter((rowKey) => hierarchyUUIDs.includes(rowKey.uuid))
    .map((rowKey) => ({
      columnName: rowKey.columnName,
      rename: rowKey.rename,
      uuid: rowKey.uuid,
      _id: rowKey._id,
      dataType: rowKey.dataType,
      nanoId: rowKey.nanoId,
      format: rowKey.format,
      dateFormat: rowKey.dateFormat,
    }));

  // console.log(hierarchyItems);

  // Create a copy of rowsArray to preserve original data
  let updatedArray = [...rowsArray];

  // Find the index of the last hierarchy item in rowsArray
  const lastHierarchyIndex = rowsArray.findIndex((item) =>
    hierarchyItems.some((hierarchy) => hierarchy._id === item._id)
  );
  // console.log(hierarchyItems.length - 1);

  // Push nextItem after the hierarchyItems
  if (lastHierarchyIndex !== -1) {
    // console.log(updatedArray[lastHierarchyIndex]);
    updatedArray.splice(hierarchyItems.length, 0, nextItem);
  } else {
    // If no hierarchy item is found, append nextItem at the end
    updatedArray.push(nextItem);
  }

  // console.log(updatedArray);

  return updatedArray;
}
function dispatchableDateItemIs(foundHierachy, nextItem, requiredArray) {
  const rowsArray = requiredArray.map((rItem) => {
    // console.log(rItem);
    return {
      columnName: rItem.columnName,
      rename: rItem.rename,
      uuid: rItem.uuid,
      _id: rItem._id,
      dataType: rItem.dataType,
      nanoId: rItem.nanoId,
      format: rItem.format,
      dateFormat: rItem.dateFormat,
      dateUnit: rItem.dateUnit,
      yearType: rItem.yearType,
    };
  });
  // // console.log(stringHirarchy);
  // console.log(requiredArray);
  // // console.log(rowsArray);
  const hierarchyItems = foundHierachy.hierarchyArray.filter((hItem) =>
    requiredArray.some(
      (rItem) =>
        rItem.responseKey === `${hItem.rename}${hItem.dateFormat.value}`
    )
  );
  // console.log(hierarchyItems);
  const nextHierarchyItem = foundHierachy.hierarchyArray.find(
    (item) => item.nanoId === nextItem.nanoId
  );
  // console.log(nextHierarchyItem);
  // console.log(
  //   `${nextItem.rename}${nextItem.dateFormat.value}` ===
  //     `${nextHierarchyItem.rename}${nextHierarchyItem.dateFormat.value}`
  // );
  // Create a copy of rowsArray to preserve original data
  let updatedArray = [...rowsArray];

  // Find the index of the last hierarchy item in rowsArray
  const lastHierarchyIndex = rowsArray.findIndex((item) =>
    hierarchyItems.some((hierarchy) => hierarchy._id === item._id)
  );

  // Push nextItem after the hierarchyItems
  if (lastHierarchyIndex !== -1) {
    updatedArray.splice(hierarchyItems.length, 0, nextItem);
  } else {
    // If no hierarchy item is found, append nextItem at the end
    updatedArray.push(nextItem);
  }

  // console.log(updatedArray);

  return updatedArray;
}

const handleHeirarchy = ({
  headerId,
  foundHierachy,
  requiredArray,
  dispatch,
  functionToAddAndUpdate,
  functionToRemove,
  Sheetid,
  vizType,
  functionWillBe,
  groupHierarchy,
  rowHierarchy,
  rowCurrentValue,
  groupCurrentValue,
  groupIsExpandable,
  rowIsExpandable,
  headerDataType,
  dateHierarchy,
  stringHirarchy,
  headerHierarchyType,
}) => {
  // console.log(headerId);
  // console.log(headerDataType);
  // console.log(headerHierarchyType);

  switch (vizType) {
    case "simpleTable":
    case "table":
      if (foundHierachy && foundHierachy.hierarchyArray) {
        const currentIndex = foundHierachy.hierarchyArray.findIndex((arr) => {
          // console.log(arr);
          return arr.nanoId === headerId;
        });
        // console.log(currentIndex);

        if (
          currentIndex !== -1 &&
          currentIndex < foundHierachy.hierarchyArray.length - 1
        ) {
          const nextItem = foundHierachy.hierarchyArray[currentIndex + 1];
          // console.log(nextItem);
          // console.log(requiredArray);

          if (requiredArray) {
            const itemFound = requiredArray.find(
              (row) => row.nanoId === nextItem.nanoId
            );
            // console.log(itemFound);

            if (!itemFound) {
              // console.log(requiredArray);

              const dispatchedItemsAre =
                headerDataType === "String"
                  ? dispatchableStringItemIs(
                      foundHierachy,
                      nextItem,
                      requiredArray,
                      dateHierarchy
                    )
                  : dispatchableDateItemIs(
                      foundHierachy,
                      nextItem,
                      requiredArray,
                      stringHirarchy
                    );
              // console.log(dispatchedItemsAre);
              if (
                dispatchedItemsAre !== undefined &&
                headerHierarchyType === "row"
              ) {
                dispatch(
                  functionToAddAndUpdate({
                    reduxKey: "rows",
                    Sheetid,
                    parentKey: "query",
                    value: dispatchedItemsAre,
                    itemInArray: false,
                  })
                );
              }
              if (
                dispatchedItemsAre !== undefined &&
                headerHierarchyType === "column"
              ) {
                dispatch(
                  functionToAddAndUpdate({
                    reduxKey: "groupByFields",
                    Sheetid,
                    parentKey: "query",
                    value: dispatchedItemsAre,
                    itemInArray: false,
                  })
                );
              }
            } else {
              // console.log(currentIndex);

              for (
                let i = currentIndex + 1;
                i < foundHierachy.hierarchyArray.length;
                i++
              ) {
                // console.log(i);

                const itemToRemove = foundHierachy.hierarchyArray[i];
                // console.log(itemToRemove);

                const itemFoundInRowKeys = requiredArray.find(
                  (row) => row.nanoId === itemToRemove.nanoId
                );
                // // console.log(requiredArray);
                // console.log(dateHierarchy);
                // console.log(stringHirarchy);
                if (itemToRemove && headerHierarchyType === "row") {
                  // console.log(itemToRemove);
                  dispatch(
                    functionToRemove({
                      reduxKey: "rows",
                      Sheetid,
                      parentKey: "query",
                      value: itemToRemove,
                      itemInArray: true,
                      hierarchy: stringHirarchy,
                      isHierarchy: true,
                    })
                  );
                }
                if (itemToRemove && headerHierarchyType === "column") {
                  dispatch(
                    functionToRemove({
                      reduxKey: "groupByFields",
                      Sheetid,
                      parentKey: "query",
                      value: itemToRemove,
                      itemInArray: true,
                      hierarchy: stringHirarchy,
                      isHierarchy: true,
                    })
                  );
                }
              }
            }
          } else {
            // console.log("requiredArray is undefined or empty.");
          }
        }
      } else {
        // console.log("Hierarchy not found.");
      }
      break;
    case "piechart":
      if (foundHierachy && foundHierachy.hierarchyArray) {
        const currentIndex = foundHierachy.hierarchyArray.findIndex((arr) => {
          return arr.rename === headerId;
        });
        if (currentIndex !== -1) {
          if (requiredArray) {
            const isReplaceWithNext =
              functionWillBe === "replaceItemWithNextItem";
            const isReplaceWithPrevious =
              functionWillBe === "replaceItemWithpreviousItem";

            if (isReplaceWithNext || isReplaceWithPrevious) {
              const offset = isReplaceWithNext ? 1 : -1;
              const targetItem =
                foundHierachy.hierarchyArray[currentIndex + offset];

              // console.log(
              //   isReplaceWithNext
              //     ? "replaceItemWithNextItem"
              //     : "replaceItemWithpreviousItem"
              // );
              // console.log(targetItem);

              if (targetItem !== undefined) {
                dispatch(
                  functionToAddAndUpdate({
                    reduxKey: "groupByFields",
                    Sheetid,
                    parentKey: "query",
                    value: targetItem,
                    itemInArray: true,
                    index: 0,
                  })
                );
              }
            }
          } else {
            // console.log("groupBykeys is undefined or empty.");
          }
        }
      } else {
        // console.log("Hierarchy not found.");
      }
      break;
    default:
      // console.log("!simpleTable && !table && !piechart");
      // console.log(groupIsExpandable);
      // console.log(rowIsExpandable);

      if (groupIsExpandable) {
        // console.log("group is expanding");
        const groupCurrentIndex =
          groupHierarchy !== undefined &&
          groupHierarchy.hierarchyArray.findIndex(
            (row) => row.rename === groupCurrentValue
          ) + (functionWillBe === "replaceItemWithNextItem" ? 1 : -1);

        const groupNextItemIs =
          groupHierarchy !== undefined &&
          groupHierarchy.hierarchyArray[groupCurrentIndex];
        // console.log(groupNextItemIs);
        if (groupNextItemIs !== undefined) {
          dispatch(
            functionToAddAndUpdate({
              reduxKey: "groupByFields",
              Sheetid,
              parentKey: "query",
              value: groupNextItemIs,
              itemInArray: true,
              index: 0,
            })
          );
        }
      }

      if (rowIsExpandable) {
        // console.log("row is expanding");
        const rowCurrentIndex =
          rowHierarchy !== undefined &&
          rowHierarchy.hierarchyArray.findIndex(
            (row) => row.rename === rowCurrentValue
          ) + (functionWillBe === "replaceItemWithNextItem" ? 1 : -1);

        const rowNextItemIs =
          rowHierarchy !== undefined &&
          rowHierarchy.hierarchyArray[rowCurrentIndex];
        // console.log(rowNextItemIs);
        if (rowNextItemIs !== undefined) {
          dispatch(
            functionToAddAndUpdate({
              reduxKey: "rows",
              Sheetid,
              parentKey: "query",
              value: rowNextItemIs,
              itemInArray: true,
              index: 0,
            })
          );
        }
      }
      break;
  }
};

export { handleHeirarchy };
